import { render, staticRenderFns } from "./carta-hero.vue?vue&type=template&id=36c3fe2c&"
import script from "./carta-hero.vue?vue&type=script&lang=js&"
export * from "./carta-hero.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports